/**
 * Detect if running inside IS24 native app webview
 */
const ANDROID_APP_BUILD_REGEX = /ImmoScout\/android\/[^/]+\/(\d+)/i;

export const getNativePlatform = (): 'ios' | 'android' | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('immoscout/ios')) {
    return 'ios';
  }
  if (userAgent.includes('immoscout/android')) {
    return 'android';
  }
  return null;
};

export const getAndroidAppBuild = (): number | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const match = window.navigator.userAgent.match(ANDROID_APP_BUILD_REGEX);
  return match ? Number(match[1]) : null;
};

/**
 * True if inside native app
 */
export const isNativeWebView = (): boolean => {
  return getNativePlatform() !== null;
};
